import OSS from 'ali-oss';
import axios from 'axios';
import dayjs from 'dayjs';
import { ulid } from 'ulid';
import { base64ToBlob, getSuffixBase64 } from './base64';

export const getUploadName = () => {
  return dayjs().format('YYYYMMDDHHmmssSSS');
};

export const getOssSize = ({
  src,
  width,
  height,
}: {
  src?: string;
  width?: number;
  height?: number;
}) => {
  if (src && src.includes('?')) return src;
  let widthStr = '';
  let heightStr = '';
  if (width != null) {
    widthStr = `,w_${width}`;
  }
  if (height != null) {
    heightStr = `,h_${height}`;
  }
  const ret = `?x-oss-process=image/resize${widthStr}${heightStr},limit_0`;
  if (src) {
    return src + ret;
  } else {
    return ret;
  }
};

let client: OSS | null = null;

export const getOssClient = () => {
  if (!client) {
    // @ts-ignore
    const region = import.meta.env.VITE_OSS_REGION;
    // @ts-ignore
    const bucket = import.meta.env.VITE_OSS_BUCKET;
    // @ts-ignore
    const accessKeyId = import.meta.env.VITE_OSS_KEY;
    // @ts-ignore
    const accessKeySecret = import.meta.env.VITE_OSS_SECRET;

    client = new OSS({
      region,
      accessKeyId,
      accessKeySecret,
      bucket,
    });
  }
  return client;
};

export const ossUpload = async (
  data: Blob | string,
  name: string,
  opts?: { dir?: string },
) => {
  const client = await getOssClient();

  let blob: Blob;
  if (typeof data === 'string') {
    if (data.startsWith('data:image/')) {
      blob = await base64ToBlob(data);
    } else {
      blob = new Blob([data]);
    }
  } else {
    blob = data;
  }
  // @ts-ignore
  const dir = import.meta.env.VITE_OSS_DIR;
  const res = await client.put(`${opts?.dir || dir}/${name}`, blob);
  return res.url.replace('http:', 'https:');
};

export const ossCopy = async (to: string, from: string) => {
  const client = await getOssClient();
  // @ts-ignore
  const dir = import.meta.env.VITE_OSS_DIR;
  const result = await client.copy(`${dir}/${to}`, `${dir}/${from}`);
  if (result.res.status !== 200) {
    throw new Error('拷贝文件失败');
  }
};

export const uploadBase64 = async (base64: string) => {
  const suffix = getSuffixBase64(base64);
  const name = getUploadName() + '.' + suffix;
  return ossUpload(base64, name);
};

export const uploadFile = async (file: File) => {
  try {
    const arr = file.name.split('.');
    const newName = `${arr[0]}_${ulid().substring(0, 10)}.${arr[1]}`;
    const url = await ossUpload(file, newName);
    return {
      name: file.name,
      url,
    };
  } catch (err) {
    console.error(err);
    return {
      name: file.name,
      url: '',
    };
  }
};

export const getOSSInfo = async (url: string) => {
  const res = await axios.get(url + '?x-oss-process=image/info');
  return res.data as {
    ImageWidth: {
      value: number;
    };
    ImageHeight: {
      value: number;
    };
  };
};

export const ossExist = async (url: string) => {
  const client = await getOssClient();
  try {
    await client.head(url);
    return true;
  } catch (error) {
    return false;
  }
};
